'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HTMLContent = function (_React$Component) {
  _inherits(HTMLContent, _React$Component);

  function HTMLContent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HTMLContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HTMLContent.__proto__ || Object.getPrototypeOf(HTMLContent)).call.apply(_ref, [this].concat(args))), _this), _this.loadExternalScripts = function (content) {
      var loadTwtr = function loadTwtr() {
        window.twttr.events.bind('loaded', function () {
          window.dispatchEvent(new Event('image-loaded'));
        });
        window.twttr.widgets.load(document.getElementsByClassName('content')[0]);
      };
      var loadInstgrm = function loadInstgrm() {
        window.instgrm.Embeds.process();
        window.dispatchEvent(new Event('image-loaded'));
      };

      if (/instagram-media/.test(content)) {
        if (window.instgrm && window.instgrm.Embeds) {
          loadInstgrm();
        } else {
          _this.loadPlatform('//platform.instagram.com/en_US/embeds.js', loadInstgrm);
        }
      }

      if (/twitter-tweet/.test(content)) {
        if (window.twttr && window.twttr.widgets) {
          loadTwtr();
        } else {
          _this.loadPlatform('https://platform.twitter.com/widgets.js', loadTwtr);
        }
      }
    }, _this.loadPlatform = function (src, onload) {
      var newNode = document.createElement('script');
      newNode.src = src;
      newNode.onload = onload;
      document.head.appendChild(newNode);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // eslint-disable-next-line react/sort-comp


  _createClass(HTMLContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.constructor.cloneAndReplaceScriptNodes(this.container);
      this.loadExternalScripts(this.props.content);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.loadExternalScripts(this.props.content);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return (
        /* eslint-disable */
        _react2.default.createElement('div', {
          dangerouslySetInnerHTML: { __html: this.props.content },
          ref: function ref(n) {
            return _this2.container = n;
          }
        })
        /* eslint-enable */

      );
    }
  }], [{
    key: 'cloneAndReplaceScriptNodes',
    value: function cloneAndReplaceScriptNodes(node) {
      var _this3 = this;

      if (node) {
        if (node.tagName === 'SCRIPT') {
          node.parentNode.replaceChild(this.cloneScriptNode(node), node);
        } else {
          Array.from(node.childNodes).forEach(function (child) {
            return _this3.cloneAndReplaceScriptNodes(child);
          });
        }
      }
    }
  }, {
    key: 'cloneScriptNode',
    value: function cloneScriptNode(node) {
      var script = document.createElement('script');
      for (var i = 0; i < node.attributes.length; i += 1) {
        var attr = node.attributes[i];
        script.setAttribute(attr.name, attr.value);
      }
      return script;
    }
  }]);

  return HTMLContent;
}(_react2.default.Component);

HTMLContent.propTypes = {
  content: _propTypes2.default.string.isRequired
};
exports.default = HTMLContent;